import type { RfpCarrierResponse, RfpCarriersResponse } from "@platform/hooks";

export type EmailCarrier = {
  name: string;
  salesRepEmails: readonly string[];
};

const toEmailCarrier = ({
  name,
  contacts,
}: RfpCarrierResponse): EmailCarrier => ({
  name,
  salesRepEmails: contacts
    .filter(({ type }) => type === "sales_rep")
    .map(({ email }) => email),
});

export const toEmailCarriers = ({
  connected,
  unconnected,
  unknown,
}: RfpCarriersResponse): EmailCarrier[] =>
  [...(connected ?? []), ...(unconnected ?? []), ...(unknown ?? [])]
    .map(toEmailCarrier)
    .sort((a, b) => a.name.localeCompare(b.name));
